const URL = {
  GET_LOCALIZATION_STRINGS: 'localization/{languageCode}', //get
}

export default URL
